/**
 * Feature: "Get actual models" (Model Matrix admin screen follow-up,
 * 2026-09-03) — request/response contract for fetching each configured AI
 * provider's LIVE model list, replacing the hardcoded `AI_PROVIDER_MODELS`
 * map as the dropdown source once fetched.
 *
 * Endpoint (`routes/admin-ai-providers.ts`, admin-only):
 *   GET /admin/ai-providers/models          → cache-only (page load; no live
 *                                              provider call, omits a
 *                                              provider that has never been
 *                                              fetched — the UI falls back to
 *                                              AI_PROVIDER_MODELS for it)
 *   GET /admin/ai-providers/models?refresh=1 → the "Get actual models" button:
 *                                              always a live call per
 *                                              configured provider, result
 *                                              cached server-side.
 *
 * One result per DISTINCT provider currently configured across the primary/
 * secondary slots (a provider shared by both slots is fetched once). A
 * result is EITHER a fresh model-id list OR a per-provider error — one
 * provider failing never drops the other's result (see design discussion,
 * decision-log.md).
 */
import { z } from 'zod';
import { aiProviderSchema } from './ai-provider-settings.js';
export const aiProviderModelResultSchema = z.discriminatedUnion('ok', [
    z.object({
        provider: aiProviderSchema,
        ok: z.literal(true),
        models: z.array(z.string()),
    }),
    z.object({
        provider: aiProviderSchema,
        ok: z.literal(false),
        error: z.string(),
    }),
]);
/** GET /admin/ai-providers/models response — one entry per distinct configured provider. */
export const aiProviderModelsResponseSchema = z.object({
    success: z.literal(true).optional(), // web client strips `success`; backend still sends it
    results: z.array(aiProviderModelResultSchema),
});
//# sourceMappingURL=ai-provider-models.js.map